import React from 'react'
import './CheckboxRadio.scss'

const CheckboxRadio = ({ checked, onChange, label, subLabel, onClickHandler, mode, lastLabel, isCorporate}) => {
  const handleClick = () => {
    onChange(!checked)
  }

  return (
    <>
      <label
        className={`checkbox-radio ${isCorporate ? 'corporate-checkbox-radio' : `checkbox-radio-${mode}` }  ${checked ? 'checked' : ''}`}
        onClick={handleClick}>
        <input type="radio" checked={checked} onChange={() => {}} />
      </label>
      <p className='label'>
        {' '}
        {label}{' '}
        <span className={`${isCorporate ? 'corporate-sub-label' :''} sub-label`} onClick={onClickHandler}>
          {subLabel ? subLabel : null}
        </span>
        <span className="label" >
          {lastLabel ? lastLabel : null}
        </span>
      </p>
    </>
  )
}

export default CheckboxRadio
